import { smoothScroll } from './modules/_smooth_scroll';
import { modal } from './modules/_modal';
import { menuToggle } from './modules/_menu_toggle';
import { escKeyHandler } from './modules/_escKey_handler';
import AOS from 'aos';
import { profileListHoverUtil } from './modules/_profile_list_hover_util';
import { honoreesModalSlider } from './modules/_modal_slider';
import { honoreesAnchorActivate } from './modules/_honorees_anchor_activate';
// import { contentsYoutubeSlider } from './modules/_contents_youtube_slider';
import { contentsYoutubeSlider } from './modules/_contents_youtube_embed';
import { advisoryboardArticleSlider } from './modules/_advisoryboard_article_slider';

import '../css/style_tmp.css';


document.addEventListener('DOMContentLoaded', () => {
  //===================================
  // ハンバーガーメニュー開閉
  //===================================
  menuToggle();

  //===================================
  // モーダル表示
  //===================================
  modal();

  //===================================
  // HONOREES マウスホーバーで画像上にPROFILEの文字表示
  //===================================
  // honoreesHoverText();
  profileListHoverUtil(
    '.top_honorees_list_text_button',
    '.top_honorees_list_item',
    '.top_honorees_list_button'
  );
  profileListHoverUtil(
    '.top_honorees_list_profile',
    '.top_honorees_list_item',
    '.top_honorees_list_button'
  );


  //===================================
  // HONOREES モーダルスライダー
  //===================================
  honoreesModalSlider();

  //===================================
  // CONTENTS YouTube
  //===================================
  contentsYoutubeSlider();



  //===================================
  // アドバイザリーボード 記事スライダー
  //===================================
  advisoryboardArticleSlider();


  //===================================
  // アドバイザリーボード プロフィールアイコンホバー時
  //===================================
  profileListHoverUtil(
    '.advisoryboard_list_ico_button',
    '.advisoryboard_list_item',
    '.advisoryboard_list_pic'
  );


  //===================================
  // エスケープキー操作
  //===================================
  escKeyHandler();

  //===================================
  //スムーズスクロール
  //===================================
  smoothScroll();


  //===================================
  //フォント読み込み後に実行
  //===================================
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
      requestAnimationFrame(() => {
        //aos.js スクロールエフェクト
        AOS.init({
          offset: 150,
          once: true
        });

        // 2025 HONOREES アンカーリンク active 切り替え
        honoreesAnchorActivate();
      });
    });
  } else {
    // fallback（旧ブラウザなど）
    AOS.init({
      offset: 150,
      once: true
    });
    honoreesAnchorActivate();
  }

});